import images from "./images";


const team = [
    {
        id: 1,
        image: images.team1,
        name: "William Scotton",
        title: "Founder, Owner",
        biography: "William Scotton is the visionary behind our tea shop, blending tradition with innovation. With years of dedication to the art of tea, he founded the space as a haven for tea lovers seeking premium blends and a calm escape. William's focus on community building, sustainable sourcing, and authenticity sets the foundation of everything we do.",
        contacts: {
            phone: "123-456-7891",
            email: "william.scotton@teahaven.com",
            address: "101 Tea Garden Lane, Leafville, CA 90210",
        },
        accounts: {
            facebook: "/#",
            linkedin: "/#",
            twitter: "/#",
            instagram: "/#"
        },
        skills: [
            { id: 1, title: "Tea Sourcing", progress: 95 },
            { id: 2, title: "Brand Vision", progress: 92 },
            { id: 3, title: "Customer Loyalty", progress: 90 },
            { id: 4, title: "Community Building", progress: 94 },
            { id: 5, title: "Cultural Knowledge", progress: 91 },
            { id: 6, title: "Menu Development", progress: 89 },
        ]
    },
    {
        id: 2,
        image: images.team2,
        name: "Alicia Walsh",
        title: "Owner",
        biography: "Alicia Walsh plays a key role in managing daily operations and upholding the warm, inviting atmosphere our tea shop is known for. Her deep understanding of herbal wellness and customer experience makes her an indispensable part of the team. Alicia is passionate about creating a space where everyone feels at home with a cup of tea in hand.",
        contacts: {
            phone: "123-456-7892",
            email: "alicia.walsh@teahaven.com",
            address: "102 Tea Blossom Blvd, Leafville, CA 90210",
        },
        accounts: {
            facebook: "/#",
            linkedin: "/#",
            twitter: "/#",
            instagram: "/#"
        },
        skills: [
            { id: 1, title: "Customer Relations", progress: 94 },
            { id: 2, title: "Operations Management", progress: 92 },
            { id: 3, title: "Herbal Knowledge", progress: 90 },
            { id: 4, title: "Team Leadership", progress: 89 },
            { id: 5, title: "Retail Experience", progress: 88 },
            { id: 6, title: "Menu Planning", progress: 91 },
        ]
    },
    {
        id: 3,
        image: images.team3,
        name: "Billy Bates",
        title: "Manager",
        biography: "Billy Bates oversees the daily operations of the tea shop, ensuring smooth service and team coordination. With a background in hospitality and a keen eye for efficiency, Billy brings structure, energy, and positivity to the team. He’s dedicated to training staff and enhancing the customer experience through consistency and attention to detail.",
        contacts: {
            phone: "123-456-7893",
            email: "billy.bates@teahaven.com",
            address: "205 Harmony Lane, Brewtown, TX 75001",
        },
        accounts: {
            facebook: "/#",
            linkedin: "/#",
            twitter: "/#",
            instagram: "/#"
        },
        skills: [
            { id: 1, title: "Staff Management", progress: 93 },
            { id: 2, title: "Scheduling & Coordination", progress: 91 },
            { id: 3, title: "Customer Support", progress: 90 },
            { id: 4, title: "Operational Efficiency", progress: 89 },
            { id: 5, title: "Conflict Resolution", progress: 87 },
            { id: 6, title: "Sales Monitoring", progress: 88 },
        ]
    },
    {
        id: 4,
        image: images.team4,
        name: "Olive Smith",
        title: "Assistant Manager",
        biography: "Olive Smith supports daily operations, team coordination, and customer satisfaction at the tea shop. Known for her warm approach and problem-solving skills, she helps bridge communication between staff and management. Olive also plays a key role in quality assurance, staff training, and maintaining a smooth and welcoming environment for guests.",
        contacts: {
            phone: "123-456-7894",
            email: "olive.smith@teahaven.com",
            address: "782 Tea Garden Road, Steepville, CA 90210",
        },
        accounts: {
            facebook: "/#",
            linkedin: "/#",
            twitter: "/#",
            instagram: "/#"
        },
        skills: [
            { id: 1, title: "Team Support", progress: 91 },
            { id: 2, title: "Customer Relations", progress: 93 },
            { id: 3, title: "Shift Supervision", progress: 88 },
            { id: 4, title: "Training Assistance", progress: 89 },
            { id: 5, title: "Inventory Tracking", progress: 86 },
            { id: 6, title: "Conflict Mediation", progress: 87 },
        ]
    }

];

export default team;